import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import { Headphones } from "lucide-react";
import { useScrollytellTranslation } from "../Admin/scrollytellContext";

export const AudioGuideButton = ({ onClick, active = false }) => {
  const t = useScrollytellTranslation();

  return (
    <Tooltip title={t("audioGuideButton.tooltip", "Lydguide / Lydspor")}>
      <IconButton
        onClick={onClick}
        sx={{
          color: "#FFFFFF",
          backgroundColor: active ? "rgba(255, 255, 255, 0.22)" : "transparent",
          borderRadius: "4px",
          width: 44,
          height: 44,
          "&:hover": {
            backgroundColor: active
              ? "rgba(255, 255, 255, 0.3)"
              : "rgba(255, 255, 255, 0.12)",
          },
        }}
        aria-label={t("audioGuideButton.ariaLabel", "Konfigurer lydguide")}
      >
        <Headphones size={20} />
      </IconButton>
    </Tooltip>
  );
};
